export default "__VITE_ASSET__Bh6B9w4q__"